<template src="./SendBill.html"></template>
<style lang="scss" src="./SendBill.scss"></style>
<script>
import _ from 'lodash'

export default {
    name: 'SendBill',

    data () {
        return {
            status: 'form',
            uploadError: null,
            errors: [],
            values: {
                Nome: '',
                Cognome: '',
                Telefono: '',
                Email: '',
                Privacy: false,
                Bolletta: []
            }
        }
    },

    computed: {
        display() {
            return this.$store.state.sendBill.display
        },

        extraParams() {
            return this.$store.state.extraParams
        },

        formValues() {
            return this.$store.state.form.values
        },

        Prodotto() {
            return this.$store.state.form.values.Prodotto
        },

        strings() {
            return this.$store.state.strings
        },

        svg() {
            return this.$store.state.svg
        },

        Tservizio() {
            return this.$store.state.form.values.Tservizio
        },

        uploadActionPath() {
            if (window.location.hostname === 'localhost') {
                return 'http://localhost/agsm/agsm-funnel/upload.php'
            } else {
                return window.location.pathname + 'upload.php'
            }
        }
    },

    watch: {
        display(value) {
            if  (value === 'visible') {
                document.body.classList.add('unscrollable')

                // prefill
                if (this.formValues.Privacy) {
                    this.values.Nome = this.formValues.Nome
                    this.values.Cognome = this.formValues.Cog_RagSoc
                    this.values.Telefono = this.formValues.Cell || this.formValues.Tel
                    this.values.Email = this.formValues.Email
                } else {
                    this.values.Nome = ''
                    this.values.Cognome = ''
                    this.values.Telefono = ''
                    this.values.Email = ''
                }
            }
            if  (value === 'hidden') {
                document.body.classList.remove('unscrollable')
            }
        }
    },

    methods: {
        submit() {
            this.validation()
            if (this.errors.length === 0) {
                const now = new Date().getTime()
                let data = {
                    tokenId: `agsm_ticket_${now}_${Math.floor(Math.random() * 100)}`,
                    fields: _.map(this.values, (valueField, field) => ({
                        field,
                        valueField : valueField === null ? '' : valueField
                    }))
                }

                // remove Bolletta
                data.fields = data.fields.filter(params => params.field !== 'Bolletta')

                // add Bolletta fields
                this.values.Bolletta.forEach(file => {
                    data.fields.push({
                        field: 'Bolletta',
                        valueField: file.path
                    })
                })

                // append get params to data
                _.each(this.extraParams, (valueField, field) => {
                      data.fields.push({
                          field,
                          valueField
                      })
                })

                // add Prodotto
                data.fields.push({
                    field: 'Prodotto',
                    valueField: this.Prodotto
                })

                // add Tservizio
                data.fields.push({
                    field: 'Tservizio',
                    valueField: this.Tservizio
                })

                const formData = new FormData()
                formData.append('data', JSON.stringify(data))

                this.$apiCall('/StepFunnelWeb/AddDataSendBolletta', {
                    method: 'POST',
                    body: formData
                }).then(data => {
                    if (data && data.status && data.status === 200) {
                        this.status = 'success'
                    } else {
                        alert("Si sono verificati degli errori")
                    }
                })
            }
        },

        toggleHidden() {
            this.$store.commit('sendBillDisplay', 'hidden')
            setTimeout(() => { this.status = 'form' }, 1000)
        },

        validation() {
            const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
            this.errors = []

            if (!this.values.Nome) {
                this.errors.push('Nome')
            }

            if (!this.values.Cognome) {
                this.errors.push('Cognome')
            }

            if (!this.values.Telefono) {
                this.errors.push('Telefono')
            }

            if (!this.values.Privacy) {
                this.errors.push('Privacy')
            }

            if (!this.values.Bolletta) {
                this.errors.push('Bolletta')
            }

            if (!this.values.Email.match(emailRegex)) {
                this.errors.push('Email')
            }

            // this.values.forEach()
        },

        onUpload(res) {
            console.log(res)
            if (res.result === 'ok' && res.filename) {
                const path = `${window.location.origin}${window.location.pathname}uploads/${res.filename}`
                this.values.Bolletta.push({
                    filename: res.filename,
                    path: path
                })
            } else {
                this.uploadError = res.error
                this.$refs.upload.abort()
                this.errors.push('Bolletta')
            }
        },

        onRemove(file) {
            this.values.Bolletta = this.values.Bolletta.filter(_file => {
                return _file.filename !== file.response.filename
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/SendBill/SendBill.vue